import "./BackgroundCircles.css"

const BackgroundCircles = () => {
        return(
            // <div className="absolute">
            <>
                <div className="slider-thumb-1"></div>
                <div className="slider-thumb-2"></div>
                <div className="slider-thumb-3"></div>            
                </>
            // </div>
        )
}

export default BackgroundCircles